import { useModal } from 'modals';

import Text from '@cartwhl/ui/base/TextNew';
import Button from '@cartwhl/ui/input/Button';

import { contactLinks } from '../Footer/content';
import { firstContentSpacing } from '../first-content-spacing';
import { pageFrame } from '../page-frame';
import { publicPageGutters } from '../public-page-gutters';

export default function ContactPage() {
  const { open } = useModal();

  return (
    <div className={pageFrame}>
      <section
        className={`border-primary border-b pb-10 sm:pb-20 ${firstContentSpacing} ${publicPageGutters}`}
      >
        <div className="flex max-w-[813px] flex-col items-start gap-8">
          <Text
            as="h1"
            token={{ base: '24/medium', lg: '32/medium' }}
            leading="editorial"
          >
            Contact
          </Text>
          <Text
            as="p"
            token={{ base: '16', sm: '20' }}
            leading="editorial"
            className="text-secondary max-w-[640px] text-pretty"
          >
            Have a project, partnership, or question in mind? Tell us what
            you’re working on. You can also use the form for enterprise plans,
            data inquiries, education, product or technical support, and anything
            else you’d like to share.
          </Text>
          <Button
            type="button"
            variant="cta"
            onClick={() => open('ENTERPRISE_CONTACT', {})}
          >
            Contact us
          </Button>
        </div>
      </section>

      <section className={`border-primary border-b py-10 sm:py-20 ${publicPageGutters}`}>
        <Text
          as="h2"
          token={{ base: '24/medium', lg: '32/medium' }}
          leading="editorial"
          className="mb-10"
        >
          Support and community
        </Text>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {contactLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              target={link.href.startsWith('mailto:') ? undefined : '_blank'}
              rel={link.href.startsWith('mailto:') ? undefined : 'noopener noreferrer'}
              className="bg-secondary flex min-h-36 flex-col justify-between gap-8 rounded-2xl p-8"
            >
              <Text as="span" token={{ base: '24', '2xl': '28' }} leading="editorial">
                {link.label}
              </Text>
              <Text
                as="span"
                token="16"
                leading="editorial"
                className="text-secondary break-all"
              >
                {link.href.startsWith('mailto:')
                  ? link.href.slice('mailto:'.length)
                  : 'Connect with us ↗'}
              </Text>
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}
